import React from 'react';
import { Skeleton, Box, Stack } from '@mui/material';

export default function ChartSkeleton({ height = 300, showLegend = true }) {
  return (
    <Box sx={{ my: 2 }}>
      <Stack spacing={1}>
        {/* Chart area skeleton */}
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={height} 
          sx={{ 
            borderRadius: 2,
            bgcolor: 'grey.100'
          }} 
        />
        
        {/* Legend/axis label skeletons */}
        {showLegend && (
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Skeleton width={80} height={20} />
            <Skeleton width={80} height={20} />
            <Skeleton width={80} height={20} />
          </Box>
        )}
      </Stack>
    </Box>
  );
}